import { createSlice } from '@reduxjs/toolkit';

import { STORE_BASE_PATH } from '../../common/constants';

export interface AppState {
    sessionExpiredAcknowledged: boolean;
    isSearchWidget: boolean;
}

const initialState: AppState = {
    sessionExpiredAcknowledged: false,
    isSearchWidget: false,
};

export const appSlice = createSlice({
    name: `${STORE_BASE_PATH}app`,
    initialState,
    reducers: {
        hideSessionExpiredDialog: state => {
            state.sessionExpiredAcknowledged = true;
        },
        registerSearchWidget: state => {
            state.isSearchWidget = true;
        },
    },
});

export const { hideSessionExpiredDialog, registerSearchWidget } = appSlice.actions;

export default appSlice.reducer;
